/**
 *----------------------------------------------------------------------
 * Copyright (c) 2024 SOMEI
 *
 * labels
 *
 * -----
 * @summary labels
 * @author: wmegel
 * -----
 * Created Date: 08/02/2024 - 19:07:25
 * -----
 * Last Modified: 4/07/2024 - 18:28:37
 * Modified By: wmegel
 * -----
 *----------------------------------------------------------------------
*/

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-xhr-backend';

// the translations
// (tip move them in a JSON file and import them)
const resources = {
  fr: {
    translation: {
      appVersion: 'version 1.2.1',
      homeWelcomeTitle: 'Bienvenue,',
      homeWelcomeExplanationTitle: 'Vous allez transmettre votre relevé de compteur à votre service de l’eau. ',
      holder: 'Titulaire',
      meterNumber: 'N° de compteur',
      contractNumber: 'N° de contrat',
      rgpdText: 'Vos données seront traitées strictement dans le cadre du service de l’eau et ne seront pas communiquées à des tiers. ',
      nextButtonTitle: 'suivant',
      notMeButtonTitle: 'Ce n’est pas moi',
      notMeTitle: 'C’est pas vous ? ',
      notMeExplanationTitle: 'Contactez votre service de l\'eau pour mettre à jour ces coordonnées.',
      recordingInProgress: 'Enregistrement en cours…',
      unSupportedRecognitionServiceTitle: 'La saisie vocale n’est pas supportée sur votre navigateur. ',
      manualIndexSetIncitation: 'Veuillez choisir la saisie manuelle.',
      speechRecognitionTitlePart1: 'Transmettez-nous votre relevé de compteur en un clic.',
      speechRecognitionTitlePart2: ' saisie vocale !',
      manualIndexSetTitle: 'Vous avez toujours la possibilité de saisir manuellement votre relevé. ',
      manualIndexsetChoice: 'Choisir la saisie manuelle',
      submitIndexButtonTitle: 'j’envoie mon relevé',
      errorRequiredIndex: 'L\'index du compteur est obligatoire',
      errorInvalideIndex: 'Valeur incorrecte',
      errorIndexInferiorToLastIndex: 'Veuillez saisir un index supérieur au dernier index facturé',
      indexGrabSuccessTitle: 'Votre relevé de compteur a été transmis avec succès !',
      indexGrabSuccessThanks: 'Merci et à bientôt',
      compaignAlreadyAnsweredOrConfirmed: 'Le relevé de compteur a déjà été effectué. Merci et à bientôt !',
      invalidToken: 'Votre session n’est plus valide. Rendez-vous sur votre Espace Client, sur le web ou l’application pour renseigner votre relevé de compteur. ',
      accessDenied: 'Accès non autorisé',
      modalInformation: 'Je communique mon relevé du compteur d’eau qui correspond aux chiffres en noir et blanc.',
      helpText: 'Comment lire mon compteur ?',
      scanInput: 'Scan de compteur',
      voiceInput: 'Saisie vocale',
      cropExplanation: 'Déplacez et tournez la photo pour afficher les numéros du compteur dans le cadre. ',
      submitCropImage: 'JE VALIDE',
      croppedImageExplanation: 'Vérifiez l’exactitude de votre relevé de compteur (uniquement les chiffres sur fond noir). ',
      croppedImageSendIndexError: 'Les chiffres du compteur sont invalides, merci de réessayer',
      serverError: 'Une erreur est technique est survenue. Veuillez réessayer ultérieurement !',
      croppAgainButtonTitle: 'Je cadre à nouveau',
      backToIndexGrabButtonTitle: 'Autres méthodes',
      tryCroppAgain: 'je recommence',
      croppImageServerError: 'Une erreur s\'est produite lors du traitement de votre image, merci de réessayer',
      invalidPhotoServerError: 'Impossible de récupérer l\'index à partir de cette image! Veuillez la recadrer ou bien en sélectionner une autre.',
      manualInputExplanationTitlte: 'Veuillez saisir votre relevé à l\'aide du clavier (chiffres en noir et blanc de votre compteur d\'eau)',
      previousIndexTitle: 'Votre dernier index connu : '
    }
  },
  en: {
    translation: {
      test: "Welcome"
    }
  },
  es:{
    translation: {
      appVersion: 'version 1.2.1',
      homeWelcomeTitle: 'Bienvenido,',
      homeWelcomeExplanationTitle: 'Va a enviar su lectura de medidor a su servicio de agua',
      holder: 'Titular',
      meterNumber: 'Número de medidor',
      contractNumber: 'Número de contrato',
      rgpdText: 'Sus datos serán transmitidos estrictamente dentro del servicio de agua y no serán comunicados a terceros.',
      nextButtonTitle: 'Suiguiente',
      notMeButtonTitle: 'Cliente equivocado',
      notMeTitle: '¿Cliente equivocado? ',
      notMeExplanationTitle: 'Contacta el atención al cliente para la actualización de sus datos personales.',
      recordingInProgress: 'Grabación en curso…',
      unSupportedRecognitionServiceTitle: 'La saisie vocale n’est pas supportée sur votre navigateur. ',
      manualIndexSetIncitation: 'Por favor elige la entrada manual.',
      speechRecognitionTitlePart1: 'Envíenos su lectura del medidor en un clic!',
      speechRecognitionTitlePart2: 'lectura vocal !',
      manualIndexSetTitle: 'Usted siempre tiene la opción de entrar manualmente su lectura de medidor. ',
      manualIndexsetChoice: 'Elegir la entrada manual',
      submitIndexButtonTitle: 'Yo envío mi lectura',
      errorRequiredIndex: 'La lectura del medidor es obligatoria',
      errorInvalideIndex: 'Valor incorrecto',
      errorIndexInferiorToLastIndex: 'Indica una lectura superior al la ultima lectura facturada',
      indexGrabSuccessTitle: 'La lectura del medidor ha sido enviada con exito !',
      indexGrabSuccessThanks: 'Gracias y hasta pronto.',
      compaignAlreadyAnsweredOrConfirmed: 'La lectura del medidor ya a sido enviada. Gracias y hasta pronto ! ',
      invalidToken: 'Su session esta caduque. ',
      accessDenied: 'Acceso denegado',
      modalInformation: 'Transmito la lectura de mi medidor que corresponde a los nùmeros sobre fondo negro.',
      helpText: 'Como leer mi medidor?',
      scanInput: 'Foto del medidor',
      voiceInput: 'Lectura vocal',
      cropExplanation: 'Mover y girar la foto para ajustar los numéros dentro del cuadro. ',
      submitCropImage: 'VALIDAR',
      croppedImageExplanation: 'Comprobar la exactitud de la lectura del medidor (sólo los números sobre fondo negro). ',
      croppedImageSendIndexError: 'Lectura del medidor invalida, por favor intentalo de nuevo',
      serverError: 'El servidor no responde',
      croppAgainButtonTitle: 'Cuadrar de nuevo la foto',
      backToIndexGrabButtonTitle: 'Otros métodos',
      tryCroppAgain: 'comenzar de nuevo',
      croppImageServerError: 'Surgio un error durante el tratamiento de la foto. Por favor intentalo de nuevo',
      invalidPhotoServerError: 'No se ha podido recuperar el índice de esta imagen. Por favor, recórtelo o seleccione otro.',
      previousIndexTitle: 'Su último índice conocido: '
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(Backend)
  .use(initReactI18next) // passes i18n down to react-i18next
  
  .init({
    resources,
    fallbackLng: "fr",
    keySeparator: true, // we do not use keys in form messages.welcome
    debug: true,
    interpolation: {
      escapeValue: false // react already safes from xss
    },
    detection: {
      // order and from where user language should be detected
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
    
      // keys or params to lookup language from
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      lookupFromPathIndex: 0,
      lookupFromSubdomainIndex: 0,
    
      // cache user language on
      caches: ['localStorage', 'cookie'],
      excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)
    
      // optional expire and domain for set cookie
      cookieMinutes: 10,
    
      // optional htmlTag with lang attribute, the default is:
      htmlTag: document.documentElement
    }
  }, (err, t) => {
    if (err) {
      console.log(err);
        // navigator.language failed, hence it's using "en-US"
    }});

  export default i18n;
